import Echo from '../Components/Sockect/Echo';

/**
 * Detach report download handlers from the shared user.* channel.
 * Prefer this over Echo.leave so other listeners (e.g. payroll) stay subscribed.
 *
 * @param {string} channelName - e.g. user.123
 * @param {string} eventName - event without leading dot, e.g. SalesSummaryReportReady
 * @param {object} [channel] - Echo channel instance
 * @param {Function} [handler] - optional specific handler to unbind from Pusher
 */
export function clearSharedUserChannelEvent(channelName, eventName, channel, handler) {
	const bare = eventName?.startsWith('.') ? eventName.slice(1) : eventName;
	const dotted = `.${bare}`;

	try {
		channel?.stopListening?.(bare);
		channel?.stopListening?.(dotted);
	} catch (e) {}

	try {
		const pusherChannel = Echo?.connector?.pusher?.channel?.(`private-${channelName}`);
		if (!pusherChannel?.unbind) return;
		if (handler) {
			pusherChannel.unbind(bare, handler);
		} else {
			pusherChannel.unbind(bare);
		}
	} catch (e) {}
}

/**
 * Attach a one-shot download listener on the shared user channel.
 * Uses Echo dotted listen + Pusher bind (needed when backend uses broadcastAs).
 */
export function attachSharedUserChannelListener(channelName, eventName, onEvent) {
	const bare = eventName?.startsWith('.') ? eventName.slice(1) : eventName;
	const dotted = `.${bare}`;
	const channel = Echo.private(channelName);
	let handled = false;

	const handleEvent = (event) => {
		if (handled) return;
		handled = true;
		onEvent(event);
	};

	clearSharedUserChannelEvent(channelName, bare, channel);

	try {
		channel.listen(dotted, handleEvent);
	} catch (e) {}

	try {
		const pusherChannel = Echo?.connector?.pusher?.channel?.(`private-${channelName}`);
		pusherChannel?.bind?.(bare, handleEvent);
	} catch (e) {}

	const detach = () => {
		clearSharedUserChannelEvent(channelName, bare, channel, handleEvent);
	};

	return { channel, detach, handleEvent };
}
